import {
	SELECT_SUBJECT
} from '../actions/subject-select';

const INITIAL_STATE = {
    selectedSubject: {}
};

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case SELECT_SUBJECT:// start fetching posts and set loading = true
        const newState = { ...state, selectedSubject: action.payload };
        return  newState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer-select-subject.js